import styles from './SearchResultCard.module.scss';

export const HideLinkMediaCover = ({ hideLink, link, children }) => {
  return hideLink ? (
    <div
      tabIndex={0}
      role="button"
      className={[styles.link, styles.hideLink].join('')}
      onAuxClick={(ev) => {
        if (ev.button === 1) {
          window.open(link, '_blank');
        } else if (ev.button === 4) {
          window.history.go();
        } else if (ev.button === 5) {
          window.history.back();
        }
      }}
      onClick={(ev) => {
        if (
          ev.ctrlKey ||
          ev.shiftKey ||
          ev.metaKey ||
          (ev.button && ev.button === 1)
        ) {
          ev.preventDefault();
          window.open(link, '_blank');
          return;
        }
        window.location.href = link || '';
      }}
    >
      {children}
    </div>
  ) : (
    // biome-ignore lint/complexity/noUselessFragments: noUselessFragments
    <>{children}</>
  );
};
